import { createContext, useEffect, useState } from "react";

export const PEDReportContentContext = createContext();

const initialReportContentState = {
  sportsActivities: "",
  
};

export const SPORTS_ACTIVITIES = "sportsActivities";



export const PEDReportContentContextProvider = ({ children }) => {
  const [content, setContent] = useState(initialReportContentState);

  const setSubTitle = (subTitle, subTitleContent) => {
    setContent((content) => {
      const newContent = {
        ...content,
      };
      newContent[subTitle] = subTitleContent;
      return newContent;
    });
  };

  const getSubTitle = (subTitle) => {
    return content[subTitle];
  };

  useEffect(() => {
    // Get the content from the backend and use setContent to set the same
    console.log(content);
  }, [content]);

  return (
    <PEDReportContentContext.Provider
      value={{ content, setContent, setSubTitle, getSubTitle }}
    >
      {children}
    </PEDReportContentContext.Provider>
  );
};
